/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Forward_Email_LabelInputs */

const en_dialog_forward_email_label = /** @type {(inputs: Dialog_Forward_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forward your emails to`)
};

const es_dialog_forward_email_label = /** @type {(inputs: Dialog_Forward_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenvía tus correos a`)
};

/**
* | output |
* | --- |
* | "Forward your emails to" |
*
* @param {Dialog_Forward_Email_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_forward_email_label = /** @type {((inputs?: Dialog_Forward_Email_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Forward_Email_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_forward_email_label(inputs)
	return en_dialog_forward_email_label(inputs)
});